import * as React from 'react';



export default class Excel extends React.Component {
  constructor(props){
    super(props);
  }
  render() {
    return (
      <svg className={this.props.className} xmlnsXlink="http://www.w3.org/1999/xlink">
       <g id="exzeo_2.x_icon_set" fillRule="evenodd" transform="translate(-483.000000, -180.000000)">
            <g id="Group-65" transform="translate(483.000000, 180.000000)">
                <g id="Page-1" transform="translate(1.000000, 1.000000)">
                    <path d="M1.5029,2.5921 L1.5029,0.5446 C1.5029,0.4368 1.5792,0.35 1.673,0.35 L11.7516,0.35 C11.8461,0.35 11.9217,0.4368 11.9217,0.5446 L11.9217,13.2146 C11.9217,13.3224 11.8461,13.4092 11.7516,13.4092 L1.673,13.4092 C1.5792,13.4092 1.5029,13.3224 1.5029,13.2146 L1.5029,11.0796" id="Stroke-1"></path>
                    <path d="M7.39375,7.90776 L7.39375,10.97236 C7.39375,11.08016 7.30695,11.16696 7.19915,11.16696 L0.54425,11.16696 C0.43715,11.16696 0.34965,11.08016 0.34965,10.97236 L0.34965,2.78656 C0.34965,2.67946 0.43715,2.59196 0.54425,2.59196 L7.19915,2.59196 C7.30695,2.59196 7.39375,2.67946 7.39375,2.78656 L7.39375,5.85116" id="Stroke-3"></path>
                    <path d="M3.05704,4.91631 L3.63664,5.78921 C3.78714,6.01601 3.91384,6.22601 4.04754,6.45281 L4.07274,6.45281 C4.20714,6.20921 4.34154,5.99921 4.47594,5.78081 L5.04644,4.91631 L5.84444,4.91631 L4.45914,6.88051 L5.88644,8.97981 L5.04644,8.97981 L4.45074,8.06491 C4.29114,7.82971 4.15674,7.60291 4.01394,7.35931 L3.99714,7.35931 C3.86274,7.60291 3.72064,7.82061 3.56874,8.06491 L2.98144,8.97981 L2.16734,8.97981 L3.61144,6.90571 L2.23454,4.91631 L3.05704,4.91631 Z" id="Fill-5"></path>
                    <path d="M5.64375,6.88338 L10.12795,6.88338" id="Stroke-7"></path>
                    <polyline id="Stroke-9" points="8.88055 5.33918 10.12795 6.88338 8.88055 8.39818"></polyline>
                </g>
            </g>
        </g>
      </svg>
    )
  }
}
